module.exports = __webpack_public_path__ + "static/media/traktor_op.30f22a8c.png";